import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { api, errMsg } from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Loader2, MailCheck } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/auth/forgot-password", { email, password: "placeholder" });
      setSent(true);
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-50 dark:bg-[#0B0F17] p-6">
      <div className="w-full max-w-sm">
        {sent ? (
          <div className="text-center" data-testid="forgot-sent">
            <MailCheck className="mx-auto h-10 w-10 text-emerald-500" />
            <h2 className="mt-4 font-display text-xl font-bold">Check your inbox</h2>
            <p className="mt-2 text-sm text-slate-500 dark:text-slate-400">
              If {email} is registered, a reset link has been sent. It expires in 1 hour.
            </p>
          </div>
        ) : (
          <>
            <h2 className="font-display text-2xl font-bold tracking-tight">Reset password</h2>
            <p className="mt-1 text-sm text-slate-500 dark:text-slate-400">We'll email you a secure reset link.</p>
            <form onSubmit={submit} className="mt-8 space-y-4" data-testid="forgot-form">
              <div>
                <Label htmlFor="fp-email">Email</Label>
                <Input id="fp-email" data-testid="forgot-email" type="email" required value={email}
                  onChange={(e) => setEmail(e.target.value)} placeholder="you@krishnagroup.com" className="mt-1.5 h-11" />
              </div>
              <Button data-testid="forgot-submit-btn" type="submit" disabled={busy}
                className="h-11 w-full bg-slate-900 hover:bg-slate-800 dark:bg-slate-100 dark:text-slate-900 font-semibold">
                {busy && <Loader2 className="mr-2 h-4 w-4 animate-spin" />} Send reset link
              </Button>
            </form>
          </>
        )}
        <p className="mt-6 text-center text-sm">
          <Link to="/login" data-testid="back-to-login" className="font-medium text-amber-600 hover:text-amber-700 dark:text-amber-400">
            ← Back to sign in
          </Link>
        </p>
      </div>
    </div>
  );
}
